export default [
  {
    path: '/real-estate-developments/:id/documents/new',
    name: 'RealEstateDevelopmentsDocumentsCreate',
    component: () => import('pages/real-estate-developments/tabs/documents/DocumentsForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/documents/:id/edit',
    name: 'RealEstateDevelopmentsDocumentsEdit',
    component: () => import('pages/real-estate-developments/tabs/documents/DocumentsForm.vue')
  }
]
